export default function GetIcon({ icon = "", fill = false as any }) {
  return (
    <>
      {icon === "down-arrow" && (
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.351472 0.751473C0.820101 0.282844 1.5799 0.282844 2.04853 0.751473L6 4.70294L9.95147 0.751473C10.4201 0.282844 11.1799 0.282844 11.6485 0.751473C12.1172 1.2201 12.1172 1.9799 11.6485 2.44853L6.84853 7.24853C6.3799 7.71716 5.6201 7.71716 5.15147 7.24853L0.351472 2.44853C-0.117157 1.9799 -0.117157 1.2201 0.351472 0.751473Z"
            fill={fill ? fill : "#5A6D77"}
          />
        </svg>
      )}
      {icon === "up-arrow" && (
        <svg
          width="12"
          height="8"
          viewBox="0 0 12 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.6485 7.24853C11.1799 7.71716 10.4201 7.71716 9.95147 7.24853L6 3.29705L2.04853 7.24853C1.5799 7.71716 0.820101 7.71715 0.351472 7.24853C-0.117157 6.7799 -0.117157 6.0201 0.351472 5.55147L5.15147 0.75147C5.6201 0.28284 6.3799 0.28284 6.84853 0.75147L11.6485 5.55147C12.1172 6.0201 12.1172 6.7799 11.6485 7.24853Z"
            fill={fill ? fill : "#5A6D77"}
          />
        </svg>
      )}
      {icon === "right-arrow" && (
        <svg
          width="8"
          height="12"
          viewBox="0 0 8 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.753206 11.6485C0.284577 11.1799 0.284577 10.4201 0.753206 9.95147L4.70468 6L0.753205 2.04853C0.284576 1.5799 0.284576 0.820101 0.753205 0.351472C1.22183 -0.117157 1.98163 -0.117157 2.45026 0.351472L7.25026 5.15147C7.71889 5.6201 7.71889 6.3799 7.25026 6.84853L2.45026 11.6485C1.98163 12.1172 1.22183 12.1172 0.753206 11.6485Z"
            fill={fill ? fill : "#5A6D77"}
          />
        </svg>
      )}
      {icon === "calendar" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="ml-3"
        >
          <path
            d="M6.00171 5V1M14.0017 5V1M5.00171 9H15.0017M3.00171 19H17.0017C18.1063 19 19.0017 18.1046 19.0017 17V5C19.0017 3.89543 18.1063 3 17.0017 3H3.00171C1.89714 3 1.00171 3.89543 1.00171 5V17C1.00171 18.1046 1.89714 19 3.00171 19Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "official-exchanges" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5 2C6.67157 2 6 2.67157 6 3.5C6 4.32843 6.67157 5 7.5 5H9V3.5C9 2.67157 8.32843 2 7.5 2ZM10.3627 1.48579C9.72918 0.587063 8.68315 0 7.5 0C5.567 0 4 1.567 4 3.5C4 4.0368 4.12085 4.54537 4.33682 5H3C1.34315 5 0 6.34315 0 8C0 9.30622 0.834808 10.4175 2 10.8293L2 17C2 18.6569 3.34315 20 5 20H15C16.6569 20 18 18.6569 18 17V10.8293C19.1652 10.4175 20 9.30622 20 8C20 6.34315 18.6569 5 17 5H14.8293C14.9398 4.68722 15 4.35064 15 4C15 2.34315 13.6569 1 12 1C11.3959 1 10.8335 1.17856 10.3627 1.48579ZM11 4V4.99997L12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4ZM9 7H3C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9H9V7ZM9 11H4V17C4 17.5523 4.44772 18 5 18H9V11ZM11 18V11H16V17C16 17.5523 15.5523 18 15 18H11ZM11 9V7H17C17.5523 7 18 7.44772 18 8C18 8.55228 17.5523 9 17 9H11Z"
            fill={fill ? fill : "#5A6D77"}
          />
        </svg>
      )}
      {icon === "user-exchanges" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.5 2C6.67157 2 6 2.67157 6 3.5C6 4.32843 6.67157 5 7.5 5H9V3.5C9 2.67157 8.32843 2 7.5 2ZM10.3627 1.48579C9.72918 0.587063 8.68315 0 7.5 0C5.567 0 4 1.567 4 3.5C4 4.0368 4.12085 4.54537 4.33682 5H3C1.34315 5 0 6.34315 0 8C0 9.30622 0.834808 10.4175 2 10.8293L2 17C2 18.6569 3.34315 20 5 20H15C16.6569 20 18 18.6569 18 17V10.8293C19.1652 10.4175 20 9.30622 20 8C20 6.34315 18.6569 5 17 5H14.8293C14.9398 4.68722 15 4.35064 15 4C15 2.34315 13.6569 1 12 1C11.3959 1 10.8335 1.17856 10.3627 1.48579ZM11 4V4.99997L12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3C11.4477 3 11 3.44772 11 4ZM9 7H3C2.44772 7 2 7.44772 2 8C2 8.55228 2.44772 9 3 9H9V7ZM9 11H4V17C4 17.5523 4.44772 18 5 18H9V11ZM11 18V11H16V17C16 17.5523 15.5523 18 15 18H11ZM11 9V7H17C17.5523 7 18 7.44772 18 8C18 8.55228 17.5523 9 17 9H11Z"
            fill={fill ? fill : "#5A6D77"}
          />
        </svg>
      )}
      {icon === "exchange-calendar" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 0C6.55228 0 7 0.447715 7 1V2H13V1C13 0.447715 13.4477 0 14 0C14.5523 0 15 0.447715 15 1V2H17C18.6569 2 20 3.34315 20 5V17C20 18.6569 18.6569 20 17 20H3C1.34315 20 0 18.6569 0 17V5C0 3.34315 1.34315 2 3 2H5V1C5 0.447715 5.44772 0 6 0ZM5 4H3C2.44772 4 2 4.44772 2 5V17C2 17.5523 2.44772 18 3 18H17C17.5523 18 18 17.5523 18 17V5C18 4.44772 17.5523 4 17 4H15V5C15 5.55228 14.5523 6 14 6C13.4477 6 13 5.55228 13 5V4H7V5C7 5.55228 6.55228 6 6 6C5.44772 6 5 5.55228 5 5V4ZM4 9C4 8.44772 4.44772 8 5 8H15C15.5523 8 16 8.44772 16 9C16 9.55229 15.5523 10 15 10H5C4.44772 10 4 9.55229 4 9Z"
            fill={fill ? fill : "#5A6D77"}
          />
        </svg>
      )}
      {icon === "rematchers-needed" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 0C3.55228 0 4 0.447715 4 1V2H5C5.55228 2 6 2.44772 6 3C6 3.55228 5.55228 4 5 4H4V5C4 5.55228 3.55228 6 3 6C2.44772 6 2 5.55228 2 5V4H1C0.447715 4 0 3.55228 0 3C0 2.44772 0.447715 2 1 2H2V1C2 0.447715 2.44772 0 3 0ZM11 0C11.4304 0 11.8126 0.27543 11.9487 0.683772L14.0835 7.08833L19.3511 9.06367C19.7414 9.21003 20 9.58316 20 10C20 10.4168 19.7414 10.79 19.3511 10.9363L14.0835 12.9117L11.9487 19.3162C11.8126 19.7246 11.4304 20 11 20C10.5696 20 10.1874 19.7246 10.0513 19.3162L7.91647 12.9117L2.64888 10.9363C2.25857 10.79 2 10.4168 2 10C2 9.58316 2.25857 9.21003 2.64888 9.06367L7.91647 7.08833L10.0513 0.683772C10.1874 0.27543 10.5696 0 11 0ZM11 4.16228L9.66297 8.17337C9.56754 8.45964 9.34795 8.68752 9.06541 8.79347L5.848 10L9.06541 11.2065C9.34795 11.3125 9.56754 11.5404 9.66297 11.8266L11 15.8377L12.337 11.8266C12.4325 11.5404 12.652 11.3125 12.9346 11.2065L16.152 10L12.9346 8.79347C12.652 8.68752 12.4325 8.45964 12.337 8.17337L11 4.16228ZM4 14C4.55228 14 5 14.4477 5 15V16H6C6.55228 16 7 16.4477 7 17C7 17.5523 6.55228 18 6 18H5V19C5 19.5523 4.55228 20 4 20C3.44772 20 3 19.5523 3 19V18H2C1.44772 18 1 17.5523 1 17C1 16.4477 1.44772 16 2 16H3V15C3 14.4477 3.44772 14 4 14Z"
            fill={fill ? fill : "#5A6D77"}
          />
        </svg>
      )}
      {icon === "gallery" && (
        <svg
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 13L5.58579 8.41421C6.36683 7.63317 7.63316 7.63316 8.41421 8.41421L13 13M11 11L12.5858 9.41421C13.3668 8.63317 14.6332 8.63316 15.4142 9.41421L17 11M11 5H11.01M3 17H15C16.1046 17 17 16.1046 17 15V3C17 1.89543 16.1046 1 15 1H3C1.89543 1 1 1.89543 1 3V15C1 16.1046 1.89543 17 3 17Z"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "most-liked" && (
        <svg
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.31802 2.31802C0.56066 4.07538 0.56066 6.92462 2.31802 8.68198L10.0001 16.364L17.682 8.68198C19.4393 6.92462 19.4393 4.07538 17.682 2.31802C15.9246 0.56066 13.0754 0.56066 11.318 2.31802L10.0001 3.63609L8.68198 2.31802C6.92462 0.56066 4.07538 0.56066 2.31802 2.31802Z"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "awards" && (
        <svg
          width="22"
          height="22"
          viewBox="0 0 22 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.166 17.5H6.166M15.166 17.5C15.9616 17.5 16.7247 17.8161 17.2873 18.3787C17.8499 18.9413 18.166 19.7044 18.166 20.5H3.166C3.166 19.7044 3.48207 18.9413 4.04468 18.3787C4.60729 17.8161 5.37035 17.5 6.166 17.5M15.166 17.5V14.125C15.166 13.504 14.663 13 14.041 13H13.17M6.166 17.5V14.125C6.166 13.504 6.67 13 7.291 13H8.163M13.17 13H8.163M13.17 13C12.6083 12.03 12.2727 10.9457 12.188 9.828M8.163 13C8.72432 12.0299 9.05964 10.9456 9.144 9.828M12.188 9.828C13.196 9.59538 14.1357 9.13341 14.936 8.478M12.188 9.828C11.1865 10.059 10.1455 10.059 9.144 9.828M9.144 9.828C8.1364 9.59524 7.19604 9.13327 6.396 8.478M3.916 2.986C2.934 3.129 1.962 3.303 1 3.506C1.223 4.81479 1.87358 6.01273 2.84994 6.91238C3.82631 7.81202 5.07337 8.36261 6.396 8.478M3.916 2.986V3.25C3.916 5.358 4.882 7.24 6.396 8.478M3.916 2.986V1.471C6.122 1.16 8.376 1 10.666 1C12.957 1 15.211 1.16 17.416 1.47V2.986M17.416 2.986V3.25C17.416 5.358 16.45 7.24 14.936 8.478M17.416 2.986C18.3933 3.1282 19.3658 3.30163 20.332 3.506C20.1091 4.81464 19.4586 6.01246 18.4824 6.91209C17.5063 7.81172 16.2584 8.3624 14.936 8.478"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "how-it-works" && (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.22766 7.5C6.77678 6.33481 8.25843 5.5 10.0001 5.5C12.2092 5.5 14.0001 6.84315 14.0001 8.5C14.0001 9.89944 12.7224 11.0751 10.9943 11.4066C10.4519 11.5106 10.0001 11.9477 10.0001 12.5M10 15.5H10.01M19 10.5C19 15.4706 14.9706 19.5 10 19.5C5.02944 19.5 1 15.4706 1 10.5C1 5.52944 5.02944 1.5 10 1.5C14.9706 1.5 19 5.52944 19 10.5Z"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "who-we-are" && (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11 14.5H10V10.5H9M10 6.5H10.01M19 10.5C19 15.4706 14.9706 19.5 10 19.5C5.02944 19.5 1 15.4706 1 10.5C1 5.52944 5.02944 1.5 10 1.5C14.9706 1.5 19 5.52944 19 10.5Z"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "blog" && (
        <svg
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17 17.5H3C1.89543 17.5 1 16.6046 1 15.5L1 3.5C1 2.39543 1.89543 1.5 3 1.5L13 1.5C14.1046 1.5 15 2.39543 15 3.5V4.5M17 17.5C15.8954 17.5 15 16.6046 15 15.5L15 4.5M17 17.5C18.1046 17.5 19 16.6046 19 15.5V6.5C19 5.39543 18.1046 4.5 17 4.5L15 4.5M11 1.5L7 1.5M5 13.5H11M5 5.5H11V9.5H5V5.5Z"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "contact-and-support" && (
        <svg
          width="20"
          height="19"
          viewBox="0 0 20 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9.5H6.01M10 9.5H10.01M14 9.5H14.01M19 9.5C19 13.9183 14.9706 17.5 10 17.5C8.46073 17.5 7.01172 17.1565 5.74467 16.5511L1 17.5L2.39499 13.78C1.51156 12.5423 1 11.0743 1 9.5C1 5.08172 5.02944 1.5 10 1.5C14.9706 1.5 19 5.08172 19 9.5Z"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "support-us" && (
        <svg
          width="20"
          height="17"
          viewBox="0 0 20 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 5.5V3.5C15 2.39543 14.1046 1.5 13 1.5H3C1.89543 1.5 1 2.39543 1 3.5V9.5C1 10.6046 1.89543 11.5 3 11.5H5M7 15.5H17C18.1046 15.5 19 14.6046 19 13.5V7.5C19 6.39543 18.1046 5.5 17 5.5H7C5.89543 5.5 5 6.39543 5 7.5V13.5C5 14.6046 5.89543 15.5 7 15.5ZM14 10.5C14 11.6046 13.1046 12.5 12 12.5C10.8954 12.5 10 11.6046 10 10.5C10 9.39543 10.8954 8.5 12 8.5C13.1046 8.5 14 9.39543 14 10.5Z"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "pencil" && (
        <svg
          width="18"
          height="17"
          viewBox="0 0 18 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.625 2.875H3.25C2.2835 2.875 1.5 3.6585 1.5 4.625V14.25C1.5 15.2165 2.2835 16 3.25 16H12.875C13.8415 16 14.625 15.2165 14.625 14.25V9.875M13.3876 1.63756C14.071 0.954146 15.179 0.954146 15.8624 1.63756C16.5459 2.32098 16.5459 3.42902 15.8624 4.11244L8.34987 11.625H5.875L5.875 9.15013L13.3876 1.63756Z"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "people" && (
        <svg
          width="22"
          height="18"
          viewBox="0 0 22 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M11.0017 2C9.89711 2 9.00168 2.89543 9.00168 4C9.00168 5.10457 9.89711 6 11.0017 6C12.1062 6 13.0017 5.10457 13.0017 4C13.0017 2.89543 12.1062 2 11.0017 2ZM7.00168 4C7.00168 1.79086 8.79254 0 11.0017 0C13.2108 0 15.0017 1.79086 15.0017 4C15.0017 6.20914 13.2108 8 11.0017 8C8.79254 8 7.00168 6.20914 7.00168 4ZM4.00168 6C3.44939 6 3.00168 6.44772 3.00168 7C3.00168 7.55228 3.44939 8 4.00168 8C4.55396 8 5.00168 7.55228 5.00168 7C5.00168 6.44772 4.55396 6 4.00168 6ZM1.00168 7C1.00168 5.34315 2.34482 4 4.00168 4C5.65853 4 7.00168 5.34315 7.00168 7C7.00168 8.65685 5.65853 10 4.00168 10C2.34482 10 1.00168 8.65685 1.00168 7ZM18.0017 6C17.4494 6 17.0017 6.44772 17.0017 7C17.0017 7.55228 17.4494 8 18.0017 8C18.554 8 19.0017 7.55228 19.0017 7C19.0017 6.44772 18.554 6 18.0017 6ZM15.0017 7C15.0017 5.34315 16.3448 4 18.0017 4C19.6585 4 21.0017 5.34315 21.0017 7C21.0017 8.65685 19.6585 10 18.0017 10C16.3448 10 15.0017 8.65685 15.0017 7ZM11.0017 11C9.31911 11 7.87684 12.0392 7.28631 13.5145C7.10301 13.9725 7.00168 14.4732 7.00168 15V16H15.0017V15C15.0017 14.4732 14.9004 13.9725 14.717 13.5145C14.1265 12.0392 12.6842 11 11.0017 11ZM17.0017 16H20.0017V15C20.0017 13.8954 19.1062 13 18.0017 13C17.5456 13 17.1254 13.1521 16.7884 13.4097C16.9275 13.917 17.0017 14.4504 17.0017 15V16ZM15.9303 11.5777C14.8471 10.0206 13.0444 9 11.0017 9C8.95898 9 7.15623 10.0206 6.07306 11.5777C5.46909 11.2114 4.75997 11 4.00168 11C1.79254 11 0.00167847 12.7909 0.00167847 15V17C0.00167847 17.5523 0.449394 18 1.00168 18H21.0017C21.554 18 22.0017 17.5523 22.0017 17V15C22.0017 12.7909 20.2108 11 18.0017 11C17.2434 11 16.5343 11.2114 15.9303 11.5777ZM5.21495 13.4097C4.878 13.1521 4.45775 13 4.00168 13C2.89711 13 2.00168 13.8954 2.00168 15V16H5.00168V15C5.00168 14.4504 5.07582 13.917 5.21495 13.4097Z"
            fill={fill ? fill : "#5A6D77"}
          />
        </svg>
      )}
      {icon === "premium-membership" && (
        <svg
          width="20"
          height="21"
          viewBox="0 0 20 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7 10.5L9 12.5L13 8.50001M18.6179 4.48434C18.4132 4.49472 18.2072 4.49997 18 4.49997C14.9265 4.49997 12.123 3.34453 9.99993 1.44434C7.87691 3.34446 5.07339 4.49985 2 4.49985C1.79277 4.49985 1.58678 4.4946 1.38213 4.48422C1.1327 5.44783 1 6.45842 1 7.50001C1 13.0915 4.82432 17.7898 10 19.122C15.1757 17.7898 19 13.0915 19 7.50001C19 6.45847 18.8673 5.44791 18.6179 4.48434Z"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "dots" && (
        <svg
          width="18"
          height="4"
          viewBox="0 0 18 4"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 2H2.01M9 2H9.01M16 2H16.01M3 2C3 2.55228 2.55228 3 2 3C1.44772 3 1 2.55228 1 2C1 1.44772 1.44772 1 2 1C2.55228 1 3 1.44772 3 2ZM10 2C10 2.55228 9.55228 3 9 3C8.44772 3 8 2.55228 8 2C8 1.44772 8.44772 1 9 1C9.55228 1 10 1.44772 10 2ZM17 2C17 2.55228 16.5523 3 16 3C15.4477 3 15 2.55228 15 2C15 1.44772 15.4477 1 16 1C16.5523 1 17 1.44772 17 2Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "faq" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.22766 7C6.77678 5.83481 8.25843 5 10.0001 5C12.2092 5 14.0001 6.34315 14.0001 8C14.0001 9.39944 12.7224 10.5751 10.9943 10.9066C10.4519 11.0106 10.0001 11.4477 10.0001 12M10 15H10.01M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "groups" && (
        <svg
          width="18"
          height="21"
          viewBox="0 0 18 21"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.6569 14.6569C13.7202 15.5935 11.7616 17.5521 10.4138 18.8999C9.63275 19.681 8.36768 19.6814 7.58663 18.9003C6.26234 17.576 4.34159 15.6553 3.34315 14.6569C0.218951 11.5327 0.218951 6.46734 3.34315 3.34315C6.46734 0.218951 11.5327 0.218951 14.6569 3.34315C17.781 6.46734 17.781 11.5327 14.6569 14.6569Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9C6 7.34315 7.34315 6 9 6C10.6569 6 12 7.34315 12 9Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "two-people" && (
        <svg
          width="19"
          height="19"
          viewBox="0 0 19 19"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.5 2.8099C10.1413 2.08329 11.0796 1.625 12.125 1.625C14.058 1.625 15.625 3.192 15.625 5.125C15.625 7.058 14.058 8.625 12.125 8.625C11.0796 8.625 10.1413 8.16671 9.5 7.4401M12.125 17.375H1.625V16.5C1.625 13.6005 3.97551 11.25 6.875 11.25C9.77449 11.25 12.125 13.6005 12.125 16.5V17.375ZM12.125 17.375H17.375V16.5C17.375 13.6005 15.0245 11.25 12.125 11.25C11.1687 11.25 10.2722 11.5057 9.5 11.9524M10.375 5.125C10.375 7.058 8.808 8.625 6.875 8.625C4.942 8.625 3.375 7.058 3.375 5.125C3.375 3.192 4.942 1.625 6.875 1.625C8.808 1.625 10.375 3.192 10.375 5.125Z"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "gift" && (
        <svg
          width="19"
          height="18"
          viewBox="0 0 19 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.5 5.5V16.875M9.5 5.5C9.5 5.5 9.5 4.19382 9.5 3.75C9.5 2.7835 10.2835 2 11.25 2C12.2165 2 13 2.7835 13 3.75C13 4.7165 12.2165 5.5 11.25 5.5C10.7273 5.5 9.5 5.5 9.5 5.5ZM9.5 5.5C9.5 5.5 9.5 3.80505 9.5 3.3125C9.5 2.10438 8.52062 1.125 7.3125 1.125C6.10438 1.125 5.125 2.10438 5.125 3.3125C5.125 4.52062 6.10438 5.5 7.3125 5.5C8.02807 5.5 9.5 5.5 9.5 5.5ZM3.375 9H15.625M3.375 9C2.4085 9 1.625 8.2165 1.625 7.25C1.625 6.2835 2.4085 5.5 3.375 5.5H15.625C16.5915 5.5 17.375 6.2835 17.375 7.25C17.375 8.2165 16.5915 9 15.625 9M3.375 9L3.375 15.125C3.375 16.0915 4.1585 16.875 5.125 16.875H13.875C14.8415 16.875 15.625 16.0915 15.625 15.125V9"
            stroke={fill ? fill : "#5A6D77"}
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "impact" && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9 1.05493C4.50005 1.55238 1 5.36745 1 10C1 14.9706 5.02944 19 10 19C14.6326 19 18.4476 15.5 18.9451 11H9V1.05493Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.4878 7H13V1.5123C15.5572 2.41613 17.5839 4.44285 18.4878 7Z"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "mini-money" && (
        <svg
          width="19"
          height="15"
          viewBox="0 0 19 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13.875 4.875V3.125C13.875 2.1585 13.0915 1.375 12.125 1.375H3.375C2.4085 1.375 1.625 2.1585 1.625 3.125V8.375C1.625 9.3415 2.4085 10.125 3.375 10.125H5.125M6.875 13.625H15.625C16.5915 13.625 17.375 12.8415 17.375 11.875V6.625C17.375 5.6585 16.5915 4.875 15.625 4.875H6.875C5.9085 4.875 5.125 5.6585 5.125 6.625V11.875C5.125 12.8415 5.9085 13.625 6.875 13.625ZM13 9.25C13 10.2165 12.2165 11 11.25 11C10.2835 11 9.5 10.2165 9.5 9.25C9.5 8.2835 10.2835 7.5 11.25 7.5C12.2165 7.5 13 8.2835 13 9.25Z"
            stroke="#5A6D77"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "mini-people" && (
        <svg
          width="21"
          height="17"
          viewBox="0 0 21 17"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14.875 15.5H19.25V13.75C19.25 12.3003 18.0747 11.125 16.625 11.125C15.7888 11.125 15.044 11.5159 14.5633 12.125M14.875 15.5H6.125M14.875 15.5V13.75C14.875 13.1758 14.7644 12.6274 14.5633 12.125M6.125 15.5H1.75V13.75C1.75 12.3003 2.92525 11.125 4.375 11.125C5.21116 11.125 5.956 11.5159 6.43672 12.125M6.125 15.5V13.75C6.125 13.1758 6.23562 12.6274 6.43672 12.125M6.43672 12.125C7.08181 10.5134 8.65796 9.375 10.5 9.375C12.342 9.375 13.9182 10.5134 14.5633 12.125M13.125 4.125C13.125 5.57475 11.9497 6.75 10.5 6.75C9.05025 6.75 7.875 5.57475 7.875 4.125C7.875 2.67525 9.05025 1.5 10.5 1.5C11.9497 1.5 13.125 2.67525 13.125 4.125ZM18.375 6.75C18.375 7.7165 17.5915 8.5 16.625 8.5C15.6585 8.5 14.875 7.7165 14.875 6.75C14.875 5.7835 15.6585 5 16.625 5C17.5915 5 18.375 5.7835 18.375 6.75ZM6.125 6.75C6.125 7.7165 5.3415 8.5 4.375 8.5C3.4085 8.5 2.625 7.7165 2.625 6.75C2.625 5.7835 3.4085 5 4.375 5C5.3415 5 6.125 5.7835 6.125 6.75Z"
            stroke="#5A6D77"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "person-white" && (
        <svg
          width="16"
          height="20"
          viewBox="0 0 16 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 5C12 7.20914 10.2091 9 8 9C5.79086 9 4 7.20914 4 5C4 2.79086 5.79086 1 8 1C10.2091 1 12 2.79086 12 5Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8 12C4.13401 12 1 15.134 1 19H15C15 15.134 11.866 12 8 12Z"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "copy" && (
        <svg
          width="19"
          height="20"
          viewBox="0 0 19 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.5 3H3.5C2.39543 3 1.5 3.89543 1.5 5V17C1.5 18.1046 2.39543 19 3.5 19H13.5C14.6046 19 15.5 18.1046 15.5 17V16M5.5 3C5.5 4.10457 6.39543 5 7.5 5H9.5C10.6046 5 11.5 4.10457 11.5 3M5.5 3C5.5 1.89543 6.39543 1 7.5 1H9.5C10.6046 1 11.5 1.89543 11.5 3M11.5 3H13.5C14.6046 3 15.5 3.89543 15.5 5V8M17.5 12H7.5M7.5 12L10.5 9M7.5 12L10.5 15"
            stroke="#5A6D77"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
      {icon === "print" && (
        <svg
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15.5 15H17.5C18.6046 15 19.5 14.1046 19.5 13V9C19.5 7.89543 18.6046 7 17.5 7H3.5C2.39543 7 1.5 7.89543 1.5 9V13C1.5 14.1046 2.39543 15 3.5 15H5.5M7.5 19H13.5C14.6046 19 15.5 18.1046 15.5 17V13C15.5 11.8954 14.6046 11 13.5 11H7.5C6.39543 11 5.5 11.8954 5.5 13V17C5.5 18.1046 6.39543 19 7.5 19ZM15.5 7V3C15.5 1.89543 14.6046 1 13.5 1H7.5C6.39543 1 5.5 1.89543 5.5 3V7H15.5Z"
            stroke="#5A6D77"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </>
  );
}
